<template>
  <div class="row offer-filter pad-top">
      <div class="col-md-12">
      <MultiSelect track-by="name" v-model="Storage.webNewSelectedFilter" :options="Storage.webNewFilter" :multiple="true"
               :hide-selected="false" :preserve-search="true"
               :placeholder="$t('statistic.webmaster')" label="name" :searchable="true"
               :disabled="disabled" ref="multiselect">
        <template slot="option" scope="props">
          <div class="option__desc">
            <span class="option__title">
             {{ props.option.name }}
            </span>
          </div>
        </template>
      </MultiSelect>
      </div>
  </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'

  export default {
    name: 'NewWmFilter',
    components: {
      MultiSelect
    },
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    mounted () {
      Storage.webNewFilter = [{ name: 'web1' }]
      Storage.webNewSelectedFilter = [{ name: 'web1' }]
    },
    data () {
      return {
        Storage: Storage
      }
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// NewWmFilter.vue?42db61f1